import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Base } from '../../primitives/Skeleton/components/Base.js';
import { Circle } from '../../primitives/Skeleton/components/Circle.js';
import { Text } from '../../primitives/Skeleton/components/Text.js';
export const Skeleton = /*#__PURE__*/_styled(({
  variant,
  ...restProps
}) => {
  switch (variant) {
    case 'circle':
      return _jsx(Circle, {
        ...restProps
      });
    case 'text':
      return _jsx(Text, {
        ...restProps
      });
    default:
      return _jsx(Base, {
        ...restProps
      });
  }
}, process.env.NODE_ENV === "production" ? {
  target: "e1izrypj0"
} : {
  target: "e1izrypj0",
  label: "Skeleton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNHIiwiZmlsZSI6IlNrZWxldG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJhc2UgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1NrZWxldG9uL2NvbXBvbmVudHMvQmFzZS5qcyc7XG5pbXBvcnQgeyBDaXJjbGUgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1NrZWxldG9uL2NvbXBvbmVudHMvQ2lyY2xlLmpzJztcbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1NrZWxldG9uL2NvbXBvbmVudHMvVGV4dC5qcyc7XG5leHBvcnQgY29uc3QgU2tlbGV0b24gPSBzdHlsZWQoKHsgdmFyaWFudCwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICBzd2l0Y2ggKHZhcmlhbnQpIHtcbiAgICAgICAgY2FzZSAnY2lyY2xlJzpcbiAgICAgICAgICAgIHJldHVybiBfanN4KENpcmNsZSwgeyAuLi5yZXN0UHJvcHMgfSk7XG4gICAgICAgIGNhc2UgJ3RleHQnOlxuICAgICAgICAgICAgcmV0dXJuIF9qc3goVGV4dCwgeyAuLi5yZXN0UHJvcHMgfSk7XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gX2pzeChCYXNlLCB7IC4uLnJlc3RQcm9wcyB9KTtcbiAgICB9XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNrZWxldG9uLmpzLm1hcCJdfQ== */");